import type { RunStatus } from "../types";
import { ui } from "../lib/ui";

const TONE: Partial<Record<RunStatus, string>> = {
  running: ui.pillRunning,
  succeeded: ui.pillSucceeded,
  failed: ui.pillFailed,
};

export function StatusPill({ status }: { status: RunStatus }) {
  return <span className={`${ui.pill} ${TONE[status] ?? ""}`}>{status}</span>;
}
